"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var _react = _interopRequireWildcard(require("react"));

var _base = require("../../base");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const PortfolioOverviewValues = ({
  totalInvestments,
  period,
  growthValue,
  growthColorValue
}) => (0, _pragma.createFelaElement)(_base.View, {
  flexDirection: "column",
  gap: "xxxsmall",
  justifyContent: "flex-start"
}, (0, _pragma.createFelaElement)(_base.Text, {
  size: "heading1",
  weight: "semiBold",
  align: "left"
}, totalInvestments), (0, _pragma.createFelaElement)(_base.View, {
  alignItems: "center"
}, (0, _pragma.createFelaElement)(_base.Text, {
  size: "heading3",
  weight: "bold",
  color: "text.".concat(growthColorValue),
  align: "left"
}, growthValue, (0, _pragma.createFelaElement)(_base.Text, {
  size: "meta",
  weight: "semiBold",
  color: "text.meta",
  family: "meta"
}, ' ', period))));

PortfolioOverviewValues.displayName = 'PortfolioOverviewValues';
var _default = PortfolioOverviewValues;
exports.default = _default;
//# sourceMappingURL=PortfolioOverviewValues.js.map